import React from 'react';
import Container from '../Container';
import Content from '../Content';
import TraderRegistrationFormSwahili from './TraderRegistrationFormSwahili';

function RegistrationTraderSwahili(props) {
    return (
        <Container>

        <Content>
         

       <TraderRegistrationFormSwahili/>
        </Content>
    </Container>
    );
}

export default RegistrationTraderSwahili;